export const ConditionMeesage = [
    {
        id: '1',
        title: 'afafafasfasfafafafafafaf',
        last_editor: 'test',
        release_date: '2019-10-20',
        takeoff_date: '2019-12-20',
        target: 'assdadas',
        click_rate: '80%',
    },
    {
        id: '2',
        title: 'wegwgewg',
        last_editor: 'test',
        release_date: '2019-10-20',
        takeoff_date: '2019-12-20',
        target:  'assdadas',
        click_rate: '80%',
    },
    {
        id: '3',
        title: 'werwerwegwg',
        last_editor: 'test',
        release_date: '2019-10-20',
        takeoff_date: '2019-12-20',
        target:  'assdadas',
        click_rate: '80%',
    }
]

export const ConditionMeesageDetail = [
    {
        id: 1,
        title:"afafafasfasfafafafafafaf",
        applicant: '陳金鳳',
        apply_date: '2019-10-20',
        selectedItem: { //同ConditionTab2
            idage:'',
            extraAge: ['',''],
            selectedMainContract1: [], //被選擇的主約、附約
            selectedMainContract2: [],
            selectedAttaContract1: [],
            selectedAttaContract2: [],
            birthmonth:'',
            agemonth: '',
            sex: '',
            groups: '',
            home_addr:{
            city:'',
            zip:'',
            street:'',
            },
            client_type: '',
            insurance_type: '',
            marry: '',
            edu: '',
            job: '',
            incomy: '',
            familyincomy: '',
            invest: '',
            finance: [],
            house: '',
            car: [],
            web_member: '',
            online: '',
            mobile: '',
            payment: '',
            email: '',
            trans_plpy: '',
            ecall: '',
            policy_loan: '',
            claimoffset: '',
            prod_codes:{
            main:'',
            atta:'',
            },
            prod_codes_n:{
            main:'',
            atta:'',
            },
            renewal: [],
            matag_month: [],
        },
        release_date: '108/10/20',
        takeoff_date: '108/12/20',
    },
    {
        id: 2,
        title:"wegwgewg",
        applicant: '陳金鳳',
        apply_date: '2019-10-20',
        selectedItem: { //同ConditionTab2
            idage:'',
            extraAge: ['',''],
            selectedMainContract1: [], //被選擇的主約、附約
            selectedMainContract2: [],
            selectedAttaContract1: [],
            selectedAttaContract2: [],
            birthmonth:'',
            agemonth: '',
            sex: '',
            groups: '',
            home_addr:{
            city:'',
            zip:'',
            street:'',
            },
            client_type: '',
            insurance_type: '',
            marry: '',
            edu: '',
            job: '',
            incomy: '',
            familyincomy: '',
            invest: '',
            finance: [],
            house: '',
            car: [],
            web_member: '',
            online: '',
            mobile: '',
            payment: '',
            email: '',
            trans_plpy: '',
            ecall: '',
            policy_loan: '',
            claimoffset: '',
            prod_codes:{
            main:'',
            atta:'',
            },
            prod_codes_n:{
            main:'',
            atta:'',
            },
            renewal: [],
            matag_month: [],
        },
        release_date: '108/10/20',
        takeoff_date: '108/12/20',
    },
    {
        id: 3,
        title:"werwerwegwg",
        applicant: '陳金鳳',
        apply_date: '2019-10-20',
        selectedItem: { //同ConditionTab2
            idage:'',
            extraAge: ['',''],
            selectedMainContract1: [], //被選擇的主約、附約
            selectedMainContract2: [],
            selectedAttaContract1: [],
            selectedAttaContract2: [],
            birthmonth:'',
            agemonth: '',
            sex: '',
            groups: '',
            home_addr:{
            city:'',
            zip:'',
            street:'',
            },
            client_type: '',
            insurance_type: '',
            marry: '',
            edu: '',
            job: '',
            incomy: '',
            familyincomy: '',
            invest: '',
            finance: [],
            house: '',
            car: [],
            web_member: '',
            online: '',
            mobile: '',
            payment: '',
            email: '',
            trans_plpy: '',
            ecall: '',
            policy_loan: '',
            claimoffset: '',
            prod_codes:{
            main:'',
            atta:'',
            },
            prod_codes_n:{
            main:'',
            atta:'',
            },
            renewal: [],
            matag_month: [],
        },
        release_date: '108/10/20',
        takeoff_date: '108/12/20',
    },

]


export const MessageData = {
    id: '10',
    applicant: '鍾OO',
    last_editor: '鍾OO',
    start_date: '2019-10-20',
    end_date: '2019-12-20',
    last_edit_date: '2019-10-20',
    apply_date: '2019-12-20',
    company: '豐原分公司',
    company_id: 1581,
    permission: 1,
    bussiness_system: [
        {
            parent_id: 1581,
            id: 125,
            title: '豐原分公司',
            salesman_count: 20,
            usage_rate: "70%",
            permission: 1,
        },
        {
            parent_id: 1581,
            id: 135,
            title: '豐原分公司永昇推展處',
            salesman_count: 25,
            usage_rate: "78%",
            permission: 1,
        }
    ]
};


export const UnitCondition = {
    body:{
        conditions_list:[
            {
                field_description: "年齡",
                field_name: "idage",
                name: "未滿15歲",
                option: "max:14",
                ser_no: 1,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "15歲以上",
                option: "min:15",
                ser_no: 2,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "自設年齡區間",
                option: "setbyuser",
                ser_no: 3,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "0-9歲(含)",
                option: "min:0|max:9",
                ser_no: 4,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "10-19歲(含)",
                option: "min:10|max:19",
                ser_no: 5,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "20-29歲(含)",
                option: "min:20|max:29",
                ser_no: 6,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "30-39歲(含)",
                option: "min:30|max:39",
                ser_no: 7,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "40-49歲(含)",
                option: "min:40|max:49",
                ser_no: 8,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "50-59歲(含)",
                option: "min:50|max:59",
                ser_no: 9,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "60-69歲(含)",
                option: "min:60|max:69",
                ser_no: 10,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "70歲以上",
                option: "min:70",
                ser_no: 11,
            },

            {
                field_description: "下月增齡",
                field_name: "agemonth",
                name: "本月",
                option: "thismonth",
                ser_no: 1,
            },
            {
                field_description: "下月增齡",
                field_name: "agemonth",
                name: "下個月",
                option: "nextmonth",
                ser_no: 2,
            },
            {
                field_description:"性別",
                field_name:"sex",
                name:"男",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"性別",
                field_name:"sex",
                name:"女",
                option:"2",
                ser_no:2, 
            },
            {
                field_description:"所屬群組",
                field_name:"groups",
                name:"顏素琴",
                option:"1",
                ser_no: '002',
            },
            {
                field_description:"所屬群組",
                field_name:"groups",
                name:"王美珠",
                option:"1",
                ser_no: '003',
            },
            {
                field_description:"婚姻",
                field_name:"marry",
                name:"未婚",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"婚姻",
                field_name:"marry",
                name:"已婚",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"教育",
                field_name:"edu",
                name:"國中以下",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"教育",
                field_name:"edu",
                name:"高中/職",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"教育",
                field_name:"edu",
                name:"專科",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"職業",
                field_name:"job",
                name:"農業",
                option:"01",
                ser_no:1,
            },
            {
                field_description:"職業",
                field_name:"job",
                name:"林業",
                option:"02",
                ser_no:2,
            },
            {
                field_description:"職業",
                field_name:"job",
                name:"漁業",
                option:"03",
                ser_no:3,
            },
            {
                field_description:"個人年所得",
                field_name:"incomy",
                name:"無",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"個人年所得",
                field_name:"incomy",
                name:"未滿30萬",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"個人年所得",
                field_name:"incomy",
                name:"30萬以上",
                option:"3/4/5/6",
                ser_no:3,
            },
            {
                field_description:"家庭年收入",
                field_name:"familyincomy",
                name:"無",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"家庭年收入",
                field_name:"familyincomy",
                name:"未滿30萬",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"家庭年收入",
                field_name:"familyincomy",
                name:"30萬以上",
                option:"3/4/5/6",
                ser_no:3,
            },
            {
                field_description:"月平均投資",
                field_name:"invest",
                name:"無",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"月平均投資",
                field_name:"invest",
                name:"未滿3000",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"月平均投資",
                field_name:"invest",
                name:"3000以上",
                option:"3/4/5/6/7",
                ser_no:3,
            },
            {
                field_description:"理財工具",
                field_name:"finance",
                name:"定存",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"理財工具",
                field_name:"finance",
                name:"保險",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"理財工具",
                field_name:"finance",
                name:"其同基金",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"住屋狀況",
                field_name:"house",
                name:"自有",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"住屋狀況",
                field_name:"house",
                name:"租賃",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"交通工具",
                field_name:"car",
                name:"無",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"交通工具",
                field_name:"car",
                name:"機車與汽車",
                option:"4",
                ser_no:4,

            },
            {
                field_description:"交通工具",
                field_name:"car",
                name:"機車",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"公司網站會員",
                field_name:"web_member",
                name:"未開通",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"公司網站會員",
                field_name:"web_member",
                name:"已開通",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"網路服務線上變更",
                field_name:"online",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"網路服務線上變更",
                field_name:"online",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"行動服務",
                field_name:"mobile",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"行動服務",
                field_name:"mobile",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"ID一指通",
                field_name:"payment",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"ID一指通",
                field_name:"payment",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"電子單據",
                field_name:"email",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"電子單據",
                field_name:"email",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"年金即將給付月份",
                field_name:"annuity_month",
                name:"本月",
                option:"thismonth",
                ser_no:1,
            },
            {
                field_description:"年金即將給付月份",
                field_name:"annuity_month",
                name:"下個月",
                option:"nextmonth",
                ser_no:2,
            },
            {
                field_description:"生日月份",
                field_name:"birthmonth",
                name:"一月",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"生日月份",
                field_name:"birthmonth",
                name:"二月",
                option:"2",
                ser_no:2,

            },
            {
                field_description:"生日月份",
                field_name:"birthmonth",
                name:"三月",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"理賠抵繳",
                field_name:"claimoffset",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"理賠抵繳",
                field_name:"claimoffset",
                name:"已申辦",
                option:"1",
                ser_no:2,

            },
            {
                field_description:"客戶關係",
                field_name:"custrl",
                name:"經手件",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"客戶關係",
                field_name:"custrl",
                name:"服務件",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"易Call保",
                field_name:"ecall",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"易Call保",
                field_name:"ecall",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"家庭年所得",
                field_name:"family_incom",
                name:"未滿60萬",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"家庭年所得",
                field_name:"family_incom",
                name:"60萬以上",
                option:"2/3/4/5/6/7",
                ser_no:2,
            }, 
            {
                field_description:"滿期金即將給付月份",
                field_name:"matag_month",
                name:"滿期金即將給付月份",
                option:"matag_month",
                ser_no:1,
            },
            {
                field_description:"滿期金即將給付月份",
                field_name:"matag_month",
                name:"年金即將給付",
                option:"annuity_month",
                ser_no:2,
            },
            {
                field_description:"保單貸款",
                field_name:"policy_loan",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"保單貸款",
                field_name:"policy_loan",
                name:"已申辦",
                option:"1",
                ser_no:2,    
            },
            {
                field_description:"轉帳申請",
                field_name:"trans_plpy",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"轉帳申請",
                field_name:"trans_plpy",
                name:"已申辦",
                option:"1",
                ser_no:2,              
            },
            {
                field_description:"滿期金即將給付",
                field_name:"matag",
                name:"選項1",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"滿期金即將給付",
                field_name:"matag",
                name:"選項2",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"滿期金即將給付",
                field_name:"matag",
                name:"選項3",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"年金即將給付",
                field_name:"annuity",
                name:"選項1",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"年金即將給付",
                field_name:"annuity",
                name:"選項2",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"年金即將給付",
                field_name:"annuity",
                name:"選項3",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"火險",
                field_name:"fire_insurance",
                name:"選項1",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"火險",
                field_name:"fire_insurance",
                name:"選項2",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"火險",
                field_name:"fire_insurance",
                name:"選項3",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"車險",
                field_name:"car_insurance",
                name:"選項1",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"車險",
                field_name:"car_insurance",
                name:"選項2",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"車險",
                field_name:"car_insurance",
                name:"選項3",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"意外險",
                field_name:"accident_insurance",
                name:"選項1",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"意外險",
                field_name:"accident_insurance",
                name:"選項2",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"意外險",
                field_name:"accident_insurance",
                name:"選項3",
                option:"3",
                ser_no:3,
            },
        ],
    },
    header:{
        message: "INITALPAGECONDITION_API : 查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E",
    }
}


export const ClientType = {
    body:{
        client_type_list:[ 
            {
                field_description:"客戶類別",
                field_name:"client_type",
                name:"經手",
                ser_no:1,   
            },
            {
                field_description:"客戶類別",
                field_name:"client_type",
                name:"服務件",
                ser_no:2,
            },
            {
                field_description:"客戶類別",
                field_name:"client_type",
                name:"經手及服務",
                ser_no:3,
            },
            {
                field_description:"客戶類別",
                field_name:"client_type",
                name:"無經手/收費關係",
                ser_no:4,
            },
        ]
    }
}

export const InsuranceType = {
    body: {
        insurance_type_list: [
            {
                name: "健康險",
                vaule: "健康險",
            },
            {
                name: "車險",
                vaule: "車險",
            },
            {
                name: "火險",
                vaule: "火險",
            },
            {
                name: "旅綜險",
                vaule: "旅綜險",
            },
            {
                name: "新種險",
                vaule: "新種險",
            },
            {
                name: "傷害險",
                vaule: "傷害險",
            },
        ],
    },
    header: {
        message: "Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}